import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiClient, isAuthenticated } from '../../utils/api';

export const fetchUsageStatus = createAsyncThunk(
    'usage/fetchStatus',
    async (_, { rejectWithValue }) => {
        if (!isAuthenticated()) return null;
        try {
            return await apiClient.getUsageStatus();
        } catch (err) {
            return rejectWithValue(err?.message || 'fetch failed');
        }
    },
);

const usageSlice = createSlice({
    name: 'usage',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchUsageStatus.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchUsageStatus.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchUsageStatus.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export const selectUsageData = (state) => state.usage.data;

export default usageSlice.reducer;
